import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { matchPaths } from '../../common/config/utils';
import en from './translations/en.json';
import es from './translations/es.json';

const DEFAULT_LANGUAGE = 'en';
const LANGUAGE = {
  en: 'en',
  es: 'es'
};

export const getCurrentLocalization = () => {
  const match = matchPaths({ pathname: ['/:locale', '/:locale/*'], path: `${ window.location.pathname }` });
  if (!match) return DEFAULT_LANGUAGE;
  const { params: { locale } } = match || {};
  if (locale === 'my') return DEFAULT_LANGUAGE;
  if (Object.keys(LANGUAGE).includes(locale)) {
    return locale;
  }
  return DEFAULT_LANGUAGE;
};

const Localization = () => {
  i18n
    .use(initReactI18next)
    .init({
      resources: {
        [LANGUAGE.en]: {
          translation: en
        },
        [LANGUAGE.es]: {
          translation: es
        },
        fallbackLng: DEFAULT_LANGUAGE
      }
    });
  i18n.changeLanguage(getCurrentLocalization());
};

export default Localization;
